<template>
  <div class="flex flex-col items-center mt-20">
    <h1 class="text-white mb-4">مزه های کافه</h1>
    <div class="flex flex-row justify-center">
      <input
        type="number"
        class="border p-2 rounded-lg text-black disabled:bg-gray-500 disabled:opacity-50 disabled:cursor-not-allowed"
        v-model="code"
      />
      <button
        class="border border-white p-2 bg-white rounded-lg mr-2"
        @click="getKala()"
      >
        <SearchIcon class="h-6 w-6" />
      </button>
    </div>
    <div class="flex flex-col items-center" v-if="lstTeste.length > 0">
      <h1 class="text-white mb-4 mt-6">افزودن مزه جدید</h1>
      <div class="flex flex-row justify-center">
        <input
          type="text"
          class="border p-2 rounded-lg text-black disabled:bg-gray-500 disabled:opacity-50 disabled:cursor-not-allowed"
          v-model="newName"
        />
        <button
          class="border border-white p-2 bg-white rounded-lg mr-2"
          @click="insertNewTeste()"
        >
          <PlusIcon class="h-6 w-6" />
        </button>
      </div>
    </div>
    <div
      class="overflow-x-scroll w-full rounded-lg p-6 mt-5"
      v-if="lstTeste.length > 0"
    >
      <table class="w-full text-base text-center text-gray-100">
        <thead class="border-b">
          <th scope="col" class="px-6 py-3">نام مزه</th>
          <th scope="col" class="px-6 py-3">عملیات</th>
        </thead>
        <tbody
          class="items-center"
          v-for="(teste, testeIndex) in this.lstTeste"
          :key="teste"
        >
          <tr
            v-for="(item, index) in teste.options"
            :key="index"
            class="border-b"
          >
            <td class="px-4 py-2" v-if="!item.editable">{{ item.name }}</td>
            <td v-else>
              <input
                v-model="item.name"
                class="rounded-md py-1 text-black text-center"
              />
            </td>
            <td
              class="px-4 py-2 flex flex-row justify-center text-yellow-500 font-bold"
            >
              <button @click="deleteTeste(testeIndex, index)">
                <TrashIcon class="h-6 w-6" />
              </button>
              <button @click="toggleEditItem(teste, index)">
                <PencilIcon class="h-6 w-6 mr-2" v-if="!item.editable" />
                <CheckIcon
                  class="h-6 w-6 mr-2"
                  v-if="item.editable"
                  @click="editTeste()"
                />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import {
  SearchIcon,
  TrashIcon,
  PencilIcon,
  PlusIcon,
  CheckIcon,
} from "@heroicons/vue/outline";
import { getKalaOption, insertNewTeste } from "../../API/API";

export default {
  name: "OptionPage",
  components: { SearchIcon, TrashIcon, PencilIcon, PlusIcon, CheckIcon },
  data() {
    return {
      lstTeste: [],
      code: "",
      newcode: "",
      kalACode: null,
    };
  },
  methods: {
    async getKala() {
      const response = await getKalaOption(this.code);

      // اطمینان از اینکه response.data.result وجود دارد
      if (response.data && response.data.result) {
        const newOptions = response.data.result.map((item) => {
          this.kalACode = item.kalA_CODE; // اضافه کردن kalA_CODE به آرایه
          return {
            kalA_CODE: item.kalA_CODE,
            options: item.options.map((option) => ({
              name: option,
              editable: false,
            })),
          };
        });

        this.lstTeste = newOptions; // به‌روزرسانی lstTeste با آرایه جدید
        console.log(this.kalACode); // چاپ kalA_CODE ها
      } else {
        console.error("No data found in response");
      }
    },
    insertNewTeste() {
      // اطمینان از اینکه newName خالی نیست
      if (this.newName.trim() !== "") {
        // به‌روزرسانی lstTeste با یک آبجکت جدید
        this.lstTeste.push({
          options: [{ name: this.newName, editable: false }],
        });
        // پاک کردن ورودی
        this.newName = "";
        const allNames = this.getTesteData();
        let newList = {
          kalA_CODE: this.kalACode,
          kalA_OPTION: allNames,
        };
        insertNewTeste(newList)
          .then((resp) => {
            this.$swal({
              icon: "success",
              title: "موفق",
              text: resp.data.message,
              confirmButtonColor: "#fcd34d",
              confirmButtonText: "باشه",
            }).then(() => {
              this.$store.dispatch("emptyCart");
              this.$router.replace("/management/OptionPage");
            });
          })
          .catch((err) => {
            this.$swal({
              icon: "error",
              title: "خطا",
              html: err,
              confirmButtonColor: "#fcd34d",
              confirmButtonText: "باشه",
            });
          });
      } else {
        console.error("Please enter a valid name.");
      }
    },
    editTeste() {
      const allNames = this.getTesteData();
      let newList = {
        kalA_CODE: this.kalACode,
        kalA_OPTION: allNames,
      };
      insertNewTeste(newList)
        .then((resp) => {
          this.$swal({
            icon: "success",
            title: "موفق",
            text: resp.data.message,
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          }).then(() => {
            this.$store.dispatch("emptyCart");
            this.$router.replace("/management/OptionPage");
          });
        })
        .catch((err) => {
          this.$swal({
            icon: "error",
            title: "خطا",
            html: err,
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        });
    },
    toggleEditItem(teste, index) {
      if (teste && teste.options && teste.options[index]) {
        teste.options[index].editable = !teste.options[index].editable;
      }
    },
    deleteTeste(testeIndex, optionIndex) {
      // اطمینان از وجود گزینه و ردیف
      if (
        this.lstTeste[testeIndex] &&
        this.lstTeste[testeIndex].options[optionIndex]
      ) {
        // حذف گزینه خاص
        this.lstTeste[testeIndex].options.splice(optionIndex, 1);
      }

      // جمع‌آوری نام‌های جدید
      const allNames = this.getTesteData();
      let newList = {
        kalA_CODE: this.kalACode,
        kalA_OPTION: allNames,
      };
      insertNewTeste(newList)
        .then((resp) => {
          this.$swal({
            icon: "success",
            title: "موفق",
            text: resp.data.message,
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          }).then(() => {
            this.$store.dispatch("emptyCart");
            this.$router.replace("/management/OptionPage");
          });
        })
        .catch((err) => {
          this.$swal({
            icon: "error",
            title: "خطا",
            html: err,
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        });
    },

    getTesteData() {
      return this.lstTeste
        .flatMap((teste) => teste.options.map((item) => item.name))
        .join("@");
    },
  },
};
</script>
